import React from 'react';
import ComparisonBars from '../custom-widgets/ComparisonBars';
import SeasonSparkline from '../custom-widgets/SeasonSparkline';
import { GaugeIcon, PerformanceIcon } from '../custom-widgets/IconAssets';
import styles from './ForensicAnalysis.module.css';

const ForensicAnalysis = ({ comparisonValueItems, comparisonRatingItems, trendData }) => {
    const highestValue = comparisonValueItems?.length
        ? Math.round(Math.max(...comparisonValueItems.map(item => item.value)))
        : 100;
    return (
        <section className={styles['desktop-analysis-grid']}>
            <div className={styles['desktop-comparison-stack']}>
                <div className={styles['desktop-analysis-item']}>
                    <h2 className={styles['desktop-section-heading']}>Forensic Value</h2>
                    <div className={`${styles['desktop-panel']} ${styles['desktop-comparison-panel']}`}>
                        <div className={styles['desktop-card-kicker']} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Comparison</span>
                            <GaugeIcon width={18} height={18} style={{ opacity: 0.6 }} />
                        </div>
                        <ComparisonBars items={comparisonValueItems} maxValue={highestValue} unit="£" suffix="M" />
                    </div>
                </div>
                <div className={styles['desktop-analysis-item']}>
                    <h2 className={styles['desktop-section-heading']}>Performance Rating</h2>
                    <div className={`${styles['desktop-panel']} ${styles['desktop-comparison-panel']}`}>
                        <div className={styles['desktop-card-kicker']} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>Comparison</span>
                            <PerformanceIcon width={18} height={18} style={{ opacity: 0.6 }} />
                        </div>
                        <ComparisonBars items={comparisonRatingItems} maxValue={10} rating={true}/>
                    </div>
                </div>
            </div>
            <div className={styles['desktop-sparkline-wrap']}>
                <h2 className={styles['desktop-section-heading']}>Season Momentum Sparkline</h2>
                <div className={`${styles['desktop-panel']} ${styles['desktop-graph-panel']}`}>
                    <div className={styles['desktop-card-kicker']}>Matches</div>
                    <SeasonSparkline data={trendData} isMember={true} />
                </div>
            </div>
        </section>
    );
};

export default ForensicAnalysis;
